import { wait } from './wait';

export const delayedCallbackExecution = async (
  delayTime: number,
  callback: () => void,
) => {
  await wait(delayTime);
  callback();
};
